<div class="lmo-loader-status-report" *ngIf="inUseLoaders$ | async as inUseLoaders; else noLoaders">
  <form [formGroup]="reportForm" (ngSubmit)="createReport()">
    <sa-filtered-autocomplete
      formControlName="mine"
      [selectOptions]="inUseLoaders"
      [displayFn]="mineDisplayFn"
      placeholderText="Select Mine"
    ></sa-filtered-autocomplete>
    <div class="flex flex-col mt-1">
      <div class="form-field-label">
        Mesh
      </div>
      <mat-form-field appearance="outline">
        <mat-select formControlName="mesh">
          <mat-option *ngFor="let mesh of meshes$$ | async; trackBy: meshes$$ | trackByKey: 'id'" [value]="mesh">{{
            mesh.type
          }}</mat-option>
        </mat-select>
        <mat-error *ngIf="reportForm.get('mesh').hasError('required')">Mesh is required</mat-error>
      </mat-form-field>
    </div>

    <div class="flex flex-col">
      <div class="form-field-label">
        Available
      </div>
      <mat-form-field appearance="outline">
        <mat-select formControlName="available">
          <mat-option [value]="true">Up</mat-option>
          <mat-option [value]="false">Down</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="flex flex-col" *ngIf="reportForm.get('eta').enabled">
      <div class="form-field-label">
        Estimated Down Time (Hours)
      </div>
      <mat-form-field appearance="outline">
        <input type="number" matInput formControlName="eta" autocomplete="off" />
        <mat-error *ngIf="reportForm.get('eta').hasError('required')">ETA is required</mat-error>
      </mat-form-field>
    </div>

    <div class="flex flex-col" *ngIf="reportForm.get('eta').enabled">
      <div class="form-field-label">
        Description
      </div>
      <mat-form-field appearance="outline">
        <textarea matInput formControlName="description" autocomplete="off"></textarea>
      </mat-form-field>
    </div>
    <button mat-raised-button color="primary" saAutomatedSelector="loader_status__create" [disabled]="isLoading">
      Create Report
    </button>
  </form>
</div>

<ng-template #noLoaders>
  <div class="alert">
    There are currently no in-use loaders.
  </div>
</ng-template>
